<template>
  <div>
    <div class="container-fluid">
      <h4 class="text-uppercase" style="color:#6190bf">
        edit data pemilik/manajemen
      </h4>
      <template v-if="status != null">
        <b-row class="p-3">
          <b-col sm="12" style="background-color:#eaf0f7">
            <b-row class="p-3 d-flex align-items-center">
              <b-col sm="1">
                <img
                  src="@/assets/img/diagnostic.png"
                  alt="register izidok klinik"
                  class="float-right mt-1"
                  height="45"
                />
              </b-col>
              <b-col sm="9">
                <ul>
                  <li style="font-weight:600">
                    Apabila alamat email diubah, maka akan dilakukan
                    <span style="color:blue"
                      >pengiriman email aktivasi ulang</span
                    >
                    ke email baru
                  </li>
                  <li
                    style="font-weight:600"
                    v-if="!formData.is_owner"
                  >
                    Apabila status diubah menjadi
                    <a href="" style="color:red">non-aktif</a> , akan
                    menyebabkan pengguna
                    <a href="" style="color:red">
                      tidak dapat melakukan login</a
                    >
                  </li>
                </ul>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>

      <div class="card card-box">
        <div class="card-body">
          <b-row>
            <b-col sm="3">
              <b-form-group style="position: relative">
                <label class="font-weight-bold">Nama</label>
                <label style="color:red"> *</label>
                <b-form-input
                  v-model="formData.nama"
                  maxlength="50"
                  type="text"
                  required
                  ref="nama_staff"
                />
                <template v-if="formData.nama == '' || formData.nama == null">
                  <label style="color: red">Kolom harus diisi</label>
                </template>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group style="position: relative">
                <label class="font-weight-bold">Alamat Email</label>
                <label style="color:red"> *</label>
                <b-form-input
                  v-model="formData.email"
                  maxlength="50"
                  type="text"
                  required
                  ref="email"
                  @input="cekValueEmail($event)"
                />
                <template v-if="formData.email == '' || formData.email == null">
                  <label style="color: red">Kolom harus diisi</label>
                </template>
                <template
                  v-else-if="
                    formData.email.match(
                      /^([A-Za-z][A-Za-z0-9\-\.\_]*)\@([A-Za-z][A-Za-z0-9\-\_]*)(\.[A-Za-z][A-Za-z0-9\-\_]*)+$/
                    ) == null
                  "
                >
                  <label style="color: red">Format email salah</label>
                </template>
                <template v-else-if="!validasiEmail && !loadEditEmail">
                  <label style="color: red">Email telah didaftarkan</label>
                </template>
                <!-- <template v-else-if="validasiEmail && !loadEdit">
                  <label style="color: #1bc943"
                    >Email dapat digunakan</label
                  >
                </template> -->
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group style="position: relative">
                <label class="font-weight-bold">No. Handphone</label>
                <label style="color:red"> *</label>
                <b-form-input
                  v-model="formData.nomor_telp"
                  maxlength="15"
                  type="text"
                  required
                  ref="nomor_telp"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
                  @input="cekValueNomor($event)"
                />
                <template
                  v-if="
                    formData.nomor_telp == '' ||
                      formData.nomor_telp == null ||
                      formData.nomor_telp.length == 0
                  "
                >
                  <label style="color: red">Kolom harus diisi</label>
                </template>
                <template
                  v-else-if="formData.nomor_telp.match(/[0-9]+/) == null"
                >
                  <label style="color: red">Hanya bisa menulis angka</label>
                </template>
                <template v-else-if="formData.nomor_telp.length < 10">
                  <label style="color: red"
                    >No.handphone minimal 10 karakter</label
                  >
                </template>
                <template v-else-if="!validasiNomor && !loadEditNomor">
                  <label style="color: red"
                    >No.Handphone telah didaftarkan</label
                  >
                </template>
              </b-form-group>
            </b-col>
            <template v-if="!formData.is_owner && status != null">
              <b-col sm="3">
                <b-form-group style="position: relative">
                  <label for="" style="font-weight:700">Account Status</label>
                  <label style="color:red"> *</label>
                  <div style="display:flex">
                    <b-form-checkbox v-model="checked" switch>
                    </b-form-checkbox>
                    <label class="ml-3">{{
                      !checked ? "Tidak Aktif" : "Aktif"
                    }}</label>
                  </div>
                </b-form-group>
              </b-col>
            </template>
            <b-col sm="6" class="offset-6 mt-5">
              <template>
                <b-button
                  class="ml-3 text-uppercase"
                  variant="primary"
                  style="font-size:17.5px;float:right;border-radius:0.65rem;"
                  @click="submitForm"
                >
                  simpan
                </b-button>
                <b-button
                  :to="{ name: 'manajemen-list' }"
                  class="text-uppercase"
                  variant="danger"
                  style="font-size:17.5px;float:right;border-radius:0.65rem;"
                >
                  tutup
                </b-button>
              </template>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from 'vuex'
import startCase from "lodash/startCase";
import debounce from "lodash/debounce";

export default {
  data: () => ({
    beingSubmit: false,
    checked: null,
    user_id: null,
    formData: {
      no_klinik: null,
      nama: null,
      email: null,
      nomor_telp: null,
      role: null
    },
    rolesSelect: [],
    selectedRole: null,
    validasiEmail: true,
    validasiNomor: true,
    status: null,
    emailBefore: null,
    nomorBefore: null,
    loadEditEmail: true,
    loadEditNomor: true
  }),
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem("IDLE") != 1) {
      this.$swal({
        title: startCase("keluar"),
        text: `Anda yakin untuk keluar dari halaman ini?`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  beforeRouteEnter(to, from, next) {
    const { params } = to;
    const { user_id } = params;
    if (!user_id) {
      next({
        name: "staff-list"
      });
    } else {
      next();
    }
  },
  mounted() {
    this.user_id = this.$router.currentRoute.params.user_id;
    this.getManajemenData();
  },
  computed: {
    ...mapGetters(["getKlinikId"])
  },
  methods: {
    submitForm() {
      let err = false;
      if (this.formData.nama == "" || this.formData.nama == null) {
        this.$refs.nama_staff.focus();
        err = true;
      } else if (
        this.formData.email == "" ||
        this.formData.email == null ||
        !this.validasiEmail ||
        this.formData.email.match(
          /^([A-Za-z][A-Za-z0-9\-\.\_]*)\@([A-Za-z][A-Za-z0-9\-\_]*)(\.[A-Za-z][A-Za-z0-9\-\_]*)+$/
        ) == null
      ) {
        this.$refs.email.focus();
        err = true;
      } else if (
        this.formData.nomor_telp == "" ||
        this.formData.nomor_telp == null ||
        !this.validasiNomor ||
        this.formData.nomor_telp.length < 10
      ) {
        this.$refs.nomor_telp.focus();
        err = true;
      }

      if (err) {
        this.$swal({
          text: `Silakan cek kembali pengisian data Anda!`,
          type: "warning"
        });
      } else {
        this.beingSubmit = true;
        this.editPasien();
      }
    },
    async editPasien() {
      try {
       
        let isActive;

        if (this.checked == true){
          isActive = 1;
        } else if (this.checked == false){
          isActive = 0;
        } else if(this.checked == null){
          isActive = this.formData.is_active;
        }

        const res = await axios.put(`${this.url_api}/klinik/management`, {
          id_user: this.user_id,
          klinik_id: this.$route.query.klinik_id,
          nama: this.formData.nama,
          email: this.formData.email,
          nomor_telp: this.formData.nomor_telp,
          is_active: isActive,
          is_owner : this.formData.is_owner
        });
        
        const { status } = res.data;
        if (status) {
          // if (res.data.data.resend) {
          if (this.emailBefore != this.formData.email) {
            this.$swal({
              text: `Penggantian email akan menyebabkan pengiriman email aktivasi ulang. Lanjutkan penggantian email?`,
              type: "warning",
              showCancelButton: true,
              cancelButtonText: "TIDAK",
              confirmButtonText: "YA",
              reverseButtons: true
            }).then(Respon => {
              if (Respon.value) {
                this.$swal({
                  text: `Email aktivasi berhasil dikirimkan`,
                  type: "success"
                }).then(res => {
                  this.beingSubmit = true;
                  this.$router.push({
                    name: "manajemen-list"
                  });
                });
              }
            });
          } else {
            this.$swal({
              text: `Data user berhasil disimpan!`,
              type: "success"
            }).then(res => {
              this.beingSubmit = true;
              this.$router.push({
                name: "manajemen-list"
              });
            });
          }
        }
      } catch (err) {
        // console.log(err);
      }
    },
    async getManajemenData() {
      this.user_id = this.$router.currentRoute.params.user_id;
      try {
        const res = await axios.get(
          `${this.url_api}/klinik/management/${this.user_id}?klinik_id=${this.$route.query.klinik_id}`
        );
        const { data } = res.data;

        this.formData = data;
        this.emailBefore = data.email;
        this.nomorBefore = data.nomor_telp;

        if (data.status == "Non-Aktif" || data.status == "Aktif") {
          if (data.status == "Aktif") {
            this.status = true;
            this.checked = true;
          } else if (data.status == "Non-Aktif") {
            this.status = false;
            this.checked = false;
          }
        }
      } catch (err) {
        // console.log(err);
      }
    },
    cekValueEmail: debounce(function(val) {
      if(this.emailBefore.toLowerCase() == val.toLowerCase()){
          return this.validasiEmail = true
      }
      
      this.loadEditEmail = false;
      axios
        .post(`${this.url_api}/klinik/management/email/cek`, {
            email: val,
            klinik_id: this.getKlinikId,
            is_edit: true,
        })
        .then(res => {
          if (val == this.emailBefore) {
            this.validasiEmail = true;
          } else if (res.data.status) {
            this.validasiEmail = true;
          } else if (!res.data.status) {
            this.validasiEmail = false;
          }
        });
    }, 500),
    cekValueNomor: debounce(function(val) {
      this.loadEditNomor = false;

      axios
        .post(`${this.url_api}/klinik/management/phone/cek`, {
            telp: val,
            klinik_id: this.getKlinikId,
            is_edit: true
        })
        .then(res => {
          if (val == this.nomorBefore) {
            this.validasiNomor = true;
          } else if (res.data.status) {
            this.validasiNomor = true;
          } else if (!res.data.status) {
            this.validasiNomor = false;
          }
        });
    }, 500)
  }
};
</script>

<style lang="scss">
.custom-dropzone {
  .dz-message {
    padding: 10rem 1rem;
  }
}
</style>
